import { Button, Stack, Typography } from '@mui/material';
import { Link } from 'react-router';

export const ForbiddenPage = () => (
  <Stack spacing={2} sx={{ alignItems: 'flex-start', py: 4 }}>
    <Typography variant="h1">アクセス権限がありません</Typography>
    <Typography sx={{ color: 'text.secondary' }}>
      この画面を表示する権限がありません。必要な場合は、管理者に権限の付与を依頼してください。
    </Typography>
    <Button component={Link} to="/" variant="outlined">
      ダッシュボードへ戻る
    </Button>
  </Stack>
);
